import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { TbPhoneCall } from 'react-icons/tb';
import { TiLocationOutline, TiMail } from 'react-icons/ti';
import { FaFacebookF, FaFacebookMessenger } from 'react-icons/fa';
import { BsLine } from 'react-icons/bs';
import FooterLogo from '../Images/logo/logo-wt.webp';

export class Footer extends Component {
  render() {
    return (
      <>
        <section className='footer pt-5 px-3'>
          <Container fluid>
            <Row>
              <Col lg={{span: 5, offset: 0}} md={{span: 5, offset: 0}} className="text-start text-md-end">
                <img src={FooterLogo} style={{width: '6rem'}} alt="footer logo" className='mb-4' />
                {/* <ul className="social">
                  {this.props.linelink ? 
                  <li className="me-2">
                    <a href={this.props.linelink} target="_blank" rel="noreferrer"><BsLine color={'#0C3559'} size={26}/></a>
                  </li>
                  : ''}
                  {this.props.facebook ? 
                  <li className="me-2">
                    <a href={this.props.facebook} target="_blank" rel="noreferrer"><FaFacebookF color={'#0C3559'} size={26}/></a>
                  </li>
                  : ''}
                  {this.props.messenger ? 
                  <li className="me-2">
                    <a href={this.props.messenger} target="_blank" rel="noreferrer"><FaFacebookMessenger color={'#0C3559'} size={26}/></a>
                  </li>
                  : ''}
                </ul> */}
              </Col>
              <Col md={4}>
                <h3>บริษัท เคทีเอ็น พลาสแพค จำกัด</h3>
                <p>โรงงานผลิตบรรจุภัณฑ์พลาสติกสำหรับอุตสาหกรรมต่างๆ ประสบการณ์การผลิตยาวนานมากกว่า 20 ปี</p>
                {/* <ul className="contact pb-3">
                  <li className="d-flex">
                    <div><TiLocationOutline color={'#FFF'}/></div>
                    <div className="ms-2">{this.props.address}</div>
                  </li>
                  <li className="d-flex">
                    <div><TiMail size={20} color={'#FFF'}/></div>
                    <div className="ms-2"><a href={"mailto:" + this.props.email}>{this.props.email}</a></div>
                  </li>
                  <li className="d-flex">
                    <div><TbPhoneCall size={20} color={'#FFF'}/></div>
                    <div className="ms-2">{this.props.phone}</div>
                  </li>
                </ul> */}
              </Col>
            </Row>
          </Container>
        </section>
      </>
    )
  }
}

export default Footer